(function () {
document.addEventListener("DOMContentLoaded", () => {
  var slider = new KeenSlider(
    ".related-articles__articles",
    {
      slides: {
        perView: 1,
      },
      loop: false,
      breakpoints: {
        "(min-width: 750px)": {
          slides: {
            perView: 3,
          },
        },
      },
    },
    [navigation]
  );
});

function navigation(slider) {
  let wrapper, dots, arrowLeft, arrowRight, navigationWrapper;

  function markup(remove) {
    wrapperMarkup(remove);
    dotMarkup(remove);
    arrowMarkup(remove);
  }

  function removeElement(elment) {
    elment.parentNode.removeChild(elment);
  }
  function createDiv(className) {
    var div = document.createElement("div");
    var classNames = className.split(" ");
    classNames.forEach((name) => div.classList.add(name));
    return div;
  }

  function createButton(className, ariaLabel) {
    var btn = document.createElement("button");
    btn.setAttribute("type", "button");
    btn.setAttribute("aria-label", ariaLabel);
    var classNames = className.split(" ");
    classNames.forEach((name) => btn.classList.add(name));
    return btn;
  }

  function arrowMarkup(remove) {
    if (remove) {
      removeElement(arrowLeft);
      removeElement(arrowRight);
      return;
    }
    arrowLeft = createButton("arrow arrow--left", "Previous slide");
    arrowLeft.addEventListener("click", () => slider.prev());
    arrowRight = createButton("arrow arrow--right", "Next slide");
    arrowRight.addEventListener("click", () => slider.next());

    arrowRight.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2.5" stroke="currentColor" class="w-6 h-6" aria-hidden="true"><path stroke-linecap="round" stroke-linejoin="round" d="M4.5 12h15m0 0l-6.75-6.75M19.5 12l-6.75 6.75" /></svg>`;
    arrowLeft.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2.5" stroke="currentColor" class="w-6 h-6" aria-hidden="true"><path stroke-linecap="round" stroke-linejoin="round" d="M19.5 12h-15m0 0l6.75 6.75M4.5 12l6.75-6.75" /></svg>`;

    navigationWrapper.appendChild(arrowLeft);
    navigationWrapper.appendChild(arrowRight);
  }

  function wrapperMarkup(remove) {
    if (remove) {
      var parent = wrapper.parentNode;
      while (wrapper.firstChild)
        parent.insertBefore(wrapper.firstChild, wrapper);
      removeElement(wrapper);
      return;
    }
    wrapper = createDiv("navigation-wrapper");
    slider.container.parentNode.appendChild(wrapper);
    navigationWrapper = createDiv("slider__navigation-wrapper");
    wrapper.appendChild(navigationWrapper);
    wrapper.appendChild(slider.container);
  }

  function dotMarkup(remove) {
    if (remove) {
      removeElement(dots);
      return;
    }
    dots = createDiv("dots");
    slider.track.details.slides.forEach((_e, idx) => {
      var dot = createDiv("dot");
      dot.addEventListener("click", () => slider.moveToIdx(idx));
      dots.appendChild(dot);
    });
    navigationWrapper.appendChild(dots);
  }

  function updateClasses() {
    var slide = slider.track.details.rel;
    var atStart = slide === 0;
    var atEnd = slide === slider.track.details.slides.length - 1;
    arrowLeft.classList.toggle("arrow--disabled", atStart);
    arrowLeft.setAttribute("aria-disabled", atStart ? "true" : "false");
    arrowRight.classList.toggle("arrow--disabled", atEnd);
    arrowRight.setAttribute("aria-disabled", atEnd ? "true" : "false");
    Array.from(dots.children).forEach(function (dot, idx) {
      idx === slide
        ? dot.classList.add("dot--active")
        : dot.classList.remove("dot--active");
    });
  }

  slider.on("created", () => {
    markup();
    updateClasses();
  });
  slider.on("optionsChanged", () => {
    console.log(2);
    markup(true);
    markup();
    updateClasses();
  });
  slider.on("slideChanged", () => {
    updateClasses();
  });
  slider.on("destroyed", () => {
    markup(true);
  });
}
})();
